import React from 'react';
import { BooleanField } from '@scale/shared/types/params/textcollection';
import { BooleanFieldAnnotation } from '@scale/shared/types/response/textcollection';
import { Checkbox, Typography, Tooltip, Icon } from '@scale/scaleui';

interface BooleanFieldSectionProps {
  field: BooleanField;
  annotation: BooleanFieldAnnotation;
  setAnnotation: (annotation: BooleanFieldAnnotation) => void;
  disabled?: boolean;
}

export default function BooleanFieldSection(props: BooleanFieldSectionProps) {
  const makeOnChange = (index: number) =>
    function (event: any, value: boolean): void {
      const response = props.annotation.response.slice();
      response[index] = value;
      const annotation: BooleanFieldAnnotation = {
        ...props.annotation,
        response,
      };
      props.setAnnotation(annotation);
    };
  const checkBoxes = props.annotation.response.map((checked: boolean, index: number) => {
    return (
      <>
        <div key={index}>
          <div className="flex gap-4">
            <div className="flex flex-row">
              <Typography.Paragraph1>{props.field.title}</Typography.Paragraph1>
              {props.field.hint && (
                <Tooltip
                  asChild
                  side="top"
                  text={props.field.hint}
                  target={
                    <div>
                      <Icon icon={['far', 'info-circle']} size="sm" />
                    </div>
                  }
                />
              )}
            </div>
            <Checkbox
              checked={checked}
              onChange={e => makeOnChange(index)(e, e.target.checked)}
              disabled={props.disabled}
            />
          </div>
          <Typography.Paragraph3>{props.field.description}</Typography.Paragraph3>
        </div>
      </>
    );
  });
  return <>{checkBoxes}</>;
}
